import { render, staticRenderFns } from "./EditBannerspaceBanner.vue?vue&type=template&id=3fe8aa84&"
import script from "./EditBannerspaceBanner.vue?vue&type=script&lang=js&"
export * from "./EditBannerspaceBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports